import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rutaContabilidad } from '../_contabilidad.js';

/**
 * Cuelga del grupo `_contabilidad` desde el 2026-09-30, cuando `categoria.administrar` pasó a
 * incluir a la contadora (adjudicación 253): ese grupo admite contador y administrador, que es el
 * mismo conjunto de roles, así que alcanza y esta ruta no repite ninguna verificación. El archivo
 * sigue en `_direccion/` para no renombrar dentro del repositorio; la dirección de la URL no cambia.
 *
 * El componente llega a pedido, con `@tanstack/query` y el panel entero detrás.
 */
export const rutaCategorias = createRoute({
  getParentRoute: () => rutaContabilidad,
  path: '/categorias',
  component: lazyRouteComponent(() => import('./categorias-pantalla.js'), 'RutaCategorias'),
});
